export enum AgingInvoicesPath {
  period = "period",
}

export interface PathParams {
  [AgingInvoicesPath.period]: string;
}
